/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import * as builder from "../../ducks/builder";
import logo from '../../../app/assets/logo/advocacia-xavier-panel-logo.svg';
import globalColors from "../../../_metronic/_assets/sass/custom/globalColors.scss";

class Brand extends React.Component {

  render() {
    return (
      <div
        style={{ backgroundColor: globalColors.backgroundColor3 }}
        className={`kt-aside__brand kt-grid__item ${this.props.brandClasses}`}
        id="kt_aside_brand"
      >
        <div className="kt-aside__brand-logo">
          <Link to="">
            <img alt="Logo advocacia-xavier Gestão" src={logo}
              style={{
                width: "100%",
              }}
            />
          </Link>
        </div>
      </div>
    );
  }
}

const mapStateToProps = store => {
  return {
    brandClasses: builder.selectors.getClasses(store, {
      path: "brand",
      toString: true
    })
  };
};

export default connect(mapStateToProps)(Brand);
